'use strict';

import ratingReviewScroll from './rating-review-scroll';

/**
 * @function fetchCompareProducts
 * @description
 * Binds change events to product variant dropdowns in the product comparison UI.
 * On variant change, updates product image, prices, refine keys, and triggers review fetch.
 */

const fetchCompareProducts = function () {
    $('.product-variant-select').on('selectmenuchange change', function () {
        const $select = $(this);
        const $selectedoption = $select.find('option:selected');

        // Extract data attributes from selected option
        const img = $selectedoption.attr('data-img');
        const url = $selectedoption.attr('data-view-url');
        const promoPrice = $selectedoption.attr('data-promoprice');
        const basePrice = $selectedoption.attr('data-baseprice');
        const refineKeys = JSON.parse($selectedoption.attr('data-refineKeys'));
        const shadeLabel = JSON.parse($selectedoption.attr('data-variant-count')).msg;
        const variantCount = JSON.parse($selectedoption.attr('data-variant-count')).countVariant;

        // Find the compare container for this select
        const $compareContainer = $selectedoption.closest('.product-compare-item');
        const selectedPid  = $selectedoption.attr('data-drpdwn-pid'); 

        // Find UI elements to update
        const $thumblink = $compareContainer.find('.thumb-link');
        const $image = $compareContainer.find('.product-compare-image');
        const $viewBtn = $compareContainer.find('.product-compare-view-btn');
        const $priceSales = $compareContainer.find('.price-sales');
        const $priceStandard = $compareContainer.find('.price-standard');
        const $refineKeysContainer = $compareContainer.find('.product-compare-refineKeys');
        const $shadeLabel = $compareContainer.find('.shade-size-label');
        const $variantCountContainer = $compareContainer.find('.count-variant');
        const $ratingContainer = $compareContainer.find('.product-compare-rating');

        // Update refine keys (attributes)
        if (Array.isArray(refineKeys) && refineKeys.length > 0) {
            let keyIdSet = {};
            refineKeys.forEach(function (key) {
                keyIdSet[key.id] = true;
                // Find all DOM elements with matching data-refine-id and update their text
                $compareContainer.find('.refine-keys[data-refine-id="' + key.id + '"]').each(function () {
                    // If key.values is null or undefined, set text to '-'
                    $(this).text(key.values != null ? key.values : '-');
                });
            });

            // For all DOM .refine-keys, if their data-refine-id is not in keyIdSet, set text to '-'
            $compareContainer.find('.refine-keys').each(function () {
                const domKeyId = $(this).data('refine-id');
                if (!keyIdSet.hasOwnProperty(domKeyId)) {
                    $(this).text('-');
                }
            });
        } else {
            // If refineKeys is null, undefined, or not an array, set all .refine-keys text to '-'
            $compareContainer.find('.refine-keys').each(function () {
                $(this).text('-');
            });
        }

        // Update UI with new values
        $image.attr('src', img);
        $thumblink.attr('href', url);
        $viewBtn.attr('href', url);

        // Price logic: show both if both exist, else show only sales
         if ($priceSales.length && $priceStandard.length && promoPrice != '' && basePrice) {
            $priceStandard.text(basePrice);
            $priceSales.text(promoPrice); 
            $priceStandard.removeClass('hide');         
        } else {
            $priceSales.text(basePrice);
            $priceStandard.addClass('hide');
        }

        $refineKeysContainer.text(refineKeys);
        $shadeLabel.text(`${shadeLabel}:`);
        $variantCountContainer.text(variantCount);
        $ratingContainer.replaceWith($('.comp-review-'+selectedPid+' .product-compare-rating').clone().addClass('compare-rating-updated'));
    });
}


/**
 * @function init
 * @description Initializes product compare dropdown logic.
 */
export default {
    init: function () {
        fetchCompareProducts();
        ratingReviewScroll.init();
    }
};